import { render, staticRenderFns } from "./esqueceuSenha.vue?vue&type=template&id=6e8a8dcf"
import script from "./esqueceuSenha.vue?vue&type=script&lang=js"
export * from "./esqueceuSenha.vue?vue&type=script&lang=js"
import style0 from "./esqueceuSenha.vue?vue&type=style&index=0&id=6e8a8dcf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports